import React from 'react';

const Plaid = () => {
  return (
    <>
      <h5>
        <b>Plaid</b>
      </h5>
      <p>
        Plaid makes it easy to securely connect your bank to the web application. There are few
        steps you have to follow to make the plugin workable.
      </p>
      <br />
    </>
  );
};

export default Plaid;
